import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from 'hooks/useAuth'

/** Chờ session; không có token/user thì về entry `/?token=`. */
const AuthGuard = () => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) return null

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}

export default AuthGuard
